import { LandingPage } from '../components/LandingPage/LandingPage.tsx'
import {
  RoutePageContents,
  RoutePageHeader,
  RoutePageTitle,
} from '../components/RouterPageLayout/RoutePageLayout.tsx'
import { UserCreatedProfileModalButton } from '../components/UserCreatedProfileModal/UserCreatedProfileModalButton/UserCreatedProfileModalButton.tsx'
import { useFetchAiPermissions } from '../hooks/useFetchAiPermissions.ts'

type CustomAiProfilesPageProps = {
  enableTMEvaluations?: boolean
  enableEvaluations?: boolean
}

export const CustomAiProfilesPage = (props: CustomAiProfilesPageProps) => {
  const { permissions } = useFetchAiPermissions()

  return (
    <>
      <RoutePageHeader className="justify-between">
        <RoutePageTitle>AI profiles (Pro AI)</RoutePageTitle>
        {permissions?.customProfile.canEdit && (
          <div className="flex justify-end">
            <UserCreatedProfileModalButton enableEvaluations={props.enableEvaluations} />
          </div>
        )}
      </RoutePageHeader>
      <RoutePageContents className="flex flex-col">
        <LandingPage {...props} />
      </RoutePageContents>
    </>
  )
}
